export default {
    widgetEnable: 'Bật tiện ích',
    signInText: 'Đăng nhập vào tài khoản của bạn',
    password: 'Mật khẩu',
    login: 'Đăng nhập',
    signin: 'Đăng nhập',
    loginTooltip1: 'điền tên đăng nhập',
    loginTooltip2: 'nhập mật khẩu',
    forgotPassword: 'Quên mật khẩu',
    registerNow: 'Đăng ký',
    registerHere: 'Đăng ký',
    dontHaveAccount: `Vẫn chưa có tài khoản ? `,
    loginText: 'Chào mừng đến với ASYX X4',
    taskManagement: 'Quản lý nhiệm vụ',
    search: 'Tìm kiếm',
    reset: 'Cài lại',
    businessKey: 'Khóa kinh doanh',
    name: 'Tên',
    companyName: 'Tên công ty',
    downPaymentGreater: 'Thanh toán xuống không thể vượt quá tổng số tiền đặt hàng',
    clientName: 'Tên khách hàng',
    created: 'Tạo',
    action: 'Hoạt động',
    actions: 'Hành động',
    taskDetail: 'Chi tiết nhiệm vụ',
    key: 'Chìa khóa',
    settlementDetail: 'Chi tiết giải quyết',
    value: 'Giá trị',
    accept: 'Chấp nhận',
    approve: 'Chấp thuận',
    reject: 'Từ chối',
    complete: 'Hoàn thành',
    edit: 'Biên tập',
    revise: 'Ôn lại',
    normalPayment: 'Thanh toán bình thường',
    documentDetail: 'Tài liệu chi tiết',
    documentType: 'loại tài liệu',
    specificReference: 'Tài liệu tham khảo cụ thể',
    specificDocumentStatus: 'Tình trạng tài liệu cụ thể',
    amountRange: 'Phạm vi số lượng',
    periodRange: 'Phạm vi thời gian',
    transactionFilter: 'Bộ lọc giao dịch',
    dateRange: 'Phạm vi ngày',
    advanceSearch: 'Trình độ cao',
    documentStatus: 'Tình trạng tài liệu',
    period: 'Giai đoạn',
    amount: 'Số lượng',
    amountMinimum: 'Số tiền tối thiểu',
    amountMaximum: 'Số tiền tối đa',
    documentReference: 'Tài liệu tham khảo',
    reference: 'Thẩm quyền giải quyết',
    seller: 'Người bán',
    buyer: 'Người mua',
    status: 'Trạng thái',
    dueDate: 'Ngày đáo hạn',
    currency: 'Tiền tệ',
    type: 'Kiểu',
    received: 'Đã nhận',
    dateReceived: 'Ngày nhận',
    disbursementTransferDate: 'Ngày chuyển giao',
    settlementTransferDate: 'Ngày chuyển giao giải quyết',
    paymentDate: 'Ngày chuyển giao',
    maturityDate: 'Ngày đáo hạn ngày',
    totalAmountDoc: 'Tổng số lượng tài liệu',
    totalNumber: 'Tổng số kết quả',
    userManagement: 'Quản lý người dùng',
    bankManagement: 'Quản lý ngân hàng',
    bankInformation: 'Thêm thông tin ngân hàng',
    localBankCode: 'Mã ngân hàng địa phương',
    branchCode: 'Mã chi nhánh',
    postCode: 'Mã bài viết',
    'bankName.isEmpty': 'Tên ngân hàng là bắt buộc',
    bankInformationisAlreadyExist: 'Thông tin ngân hàng đã tồn tại',
    bankInformationHasBeenCreated: 'Thông tin ngân hàng đã được tạo ra',
    deleteMessage: 'Bạn có chắc chắn muốn xóa dữ liệu này không',
    bulkMessage: 'Bạn có chắc muốn',
    followData: 'dữ liệu sau đây?',
    add: 'Thêm vào',
    addReferenceRate: 'Thêm tỷ lệ tham chiếu',
    addCommissionSetting: 'Thêm cài đặt hoa hồng',
    userName: 'tên tài khoản',
    view: 'Xem',
    delete: 'Xóa bỏ',
    cancel: 'Hủy bỏ',
    provideValidationMessages: '* Vui lòng cung cấp thông tin hợp lệ',
    validationUsernameMessages: '* Xin hãy điền tên đăng nhập',
    validationPasswordMessages: '* Vui lòng nhập mật khẩu của bạn',
    validationUpdatePasswordMessage:
        '* Vui lòng bao gồm số, vốn, trường hợp thấp, biểu tượng ít nhất 9 ký tự.',
    save: 'Cứu',
    userDetail: 'Chi tiết người dùng',
    username: 'tên tài khoản',
    firstName: 'Tên đầu tiên',
    middleName: 'Tên đệm',
    lastName: 'Họ',
    email: 'E-mail',
    lastLoginTime: 'Thời gian đăng nhập cuối cùng',
    account: 'Tài khoản',
    emailAddress: 'Địa chỉ email',
    emailNotification: 'thông báo có email',
    mobileNumber: 'Số điện thoại',
    smsNotification: 'Thông báo SMS',
    city: 'Thành phố',
    country: 'Quốc gia',
    languageISOCode: 'Mã ISO ngôn ngữ',
    postalCode: 'Mã bưu điện',
    address: 'Địa chỉ',
    jobTitle: 'Tiêu đề công việc',
    personTitle: 'Tiếp đầu ngữ',
    idType: 'Loại ID',
    idNumber: 'Số ID',
    otp: 'Mật khẩu một lần (OTP)',
    settings: 'Cài đặt',
    pph23Flagging: 'PPH 23',
    upfrontBilling: 'Thanh toán trả trước',
    deleteUserLDAP: 'Xóa người dùng LDAP',
    createUserLDAP: 'Tạo LDAP người dùng',
    resetPassword: 'Đặt lại mật khẩu',
    option: 'Lựa chọn',
    organizationManagement: 'Quản lý tổ chức',
    recalculate: 'Tái tính',
    organizationDetail: 'Chi tiết tổ chức',
    fullName: 'Họ và tên',
    timezone: 'Múi giờ',
    contactPerson: 'Người liên hệ',
    contactPersonDepartment: 'Liên hệ với bộ phận người',
    contactPersonPhone: 'Liên hệ với điện thoại của người',
    contactPersonEmail: 'Liên hệ email người',
    industry: 'Ngành công nghiệp',
    subIndustry: 'Công nghiệp phụ',
    billingAccountName: 'Tên tài khoản thanh toán',
    billingAccountNumber: 'Số tài khoản thanh toán',
    billingTaxable: 'Thanh toán chịu thuế',
    calendar: 'Lịch',
    authorization: 'Ủy quyền',
    organizationCalendar: 'Lịch tổ chức',
    organizationCalendarDetail: 'Lịch tổ chức chi tiết',
    exclusions: 'Loại trừ',
    addExclusions: 'Thêm loại trừ',
    date: 'Ngày',
    description: 'Sự miêu tả',
    organizationAuthorization: 'Tổ chức ủy quyền',
    organization: 'Tổ chức',
    organizations: 'Tổ chức',
    role: 'Vai trò',
    user: 'Người dùng',
    authorizationDetail: 'Chi tiết ủy quyền',
    authorizationDetailForm: 'Mẫu chi tiết ủy quyền',
    roleManagement: 'Quản lý vai trò',
    roleDetail: 'Vai trò chi tiết',
    rolePermission: 'Giấy phép vai trò',
    roleAssign: 'Gán vai trò',
    programManagement: 'Quản lý chương trình',
    programDetail: 'Chương trình chi tiết',
    supportedCurrencies: 'Tiền tệ được hỗ trợ',
    funderEnable: 'Bật tài chính',
    funderMultiple: 'Nhiều nhà tài trợ',
    funderConfigurations: 'Cấu hình tài trợ',
    buyerEnable: 'Bật người mua',
    buyerMultiple: 'Nhiều người mua',
    relation: 'Mối quan hệ',
    registeredDate: 'Ngày đăng ký',
    creditType: 'Loại tín dụng',
    buyerConfigurations: 'Cấu hình người mua',
    sellerEnable: 'Bật người bán',
    sellerMultiple: 'Nhiều người bán',
    sellerConfigurations: 'Cấu hình người bán',
    pleaseSelect: 'Vui lòng chọn...',
    contractManagement: 'Quản lí hợp đồng',
    contractDetail: 'Hợp đồng chi tiết',
    contractName: 'Tên hợp đồng',
    contractAdd: 'Thêm hợp đồng',
    contractEdit: 'Chỉnh sửa hợp đồng',
    assignProgram: 'Chỉ định chương trình',
    deactivatedContract: 'Vô hiệu hóa hợp đồng',
    organizationName: 'tên tổ chức',
    buyerOrganizations: 'Tổ chức người mua',
    sellerOrganizations: 'Các tổ chức người bán',
    funderOrganizations: 'Các tổ chức tài trợ',
    uploadQuotes: 'Tải lên báo giá',
    upload: 'Tải lên',
    buyerName: 'Tên người mua',
    supplierCode: 'Mã nhà cung cấp',
    supplierName: 'tên đệm',
    sellerName: 'Tên người bán',
    areaCode: 'Mã vùng',
    salesCode: 'Mã bán hàng',
    quoteNumber: 'Số báo giá',
    paymentTerm: 'Chính sách thanh toán',
    warehouseCode: 'Mã kho',
    deliveryFrom: 'Giao hàng từ',
    deliveryTo: 'Chuyển tới',
    creationDate: 'Ngày thành lập',
    tags: 'Trạng thái',
    expectedDeliveryDate: 'Ngày giao hàng dự kiến',
    addLineItem: 'Thêm mục dòng',
    code: 'Mã số',
    uom: 'Uom',
    price: 'Giá',
    qty: 'Số lượng',
    vat: 'Vat',
    discount: 'Giảm giá',
    submit: 'Nộp',
    createQuote: 'Tạo báo giá',
    createInvoice: 'Tạo hóa đơn',
    createShippingLetter: 'Tạo thư vận chuyển',
    senderName: 'Tên người gửi',
    receiverName: 'Tên người nhận',
    deliveryDate: 'Ngày giao hàng',
    expiryDate: 'Ngày hết hạn',
    lineItems: 'Mục hàng',
    itemCode: 'Mã hàng',
    no: 'KHÔNG.',
    documentView: 'Chế độ xem tài liệu',
    despatchAdvice: 'Lời khuyên gửi',
    despatchAdviceInventoryChecking: 'Kiểm tra hàng tồn kho',
    tracingNumber: 'Số theo dõi',
    buyerCode: 'Mã người mua',
    buyerFullName: 'Người mua tên đầy đủ',
    buyerContact: 'Người mua liên hệ',
    sellerCode: 'Mã người bán',
    sellerFullName: 'Người bán tên đầy đủ',
    sellerContact: 'Liên hệ người bán',
    orderReference: 'đơn hàng tham khảo',
    orderDate: 'Ngày đặt hàng',
    receiveDate: 'Nhận ngày',
    despatchedQuantity: 'Số lượng gửi',
    receivedQuantity: 'Nhận được số lượng',
    serviceLevel: 'Cấp độ dịch vụ',
    referenceSourceManagement: 'Quản lý nguồn tham khảo',
    ReferenceSourceAdd: 'Nguồn tham chiếu Thêm',
    referenceSourceDetail: 'Chi tiết nguồn tham chiếu',
    referenceSourceEdit: 'Chỉnh sửa nguồn tham chiếu',
    invoice: 'Hóa đơn',
    buyerNPWP: 'Số đăng ký người mua',
    sellerNPWP: 'Số đăng ký người bán',
    despatchAdviceReference: 'Tham khảo lời khuyên gửi',
    receivingAdviceReference: 'Nhận tài liệu tham khảo tư vấn',
    receivingAdviceDate: 'Nhận ngày tư vấn',
    invoiceReference: 'Tham khảo hóa đơn',
    taxSerialNumber: 'Số sê -ri thuế',
    vatAmount: 'Số tiền VAT',
    totalAmount: 'Tổng cộng',
    order: 'Đặt hàng',
    billingStatement: 'Tuyên bố thanh toán',
    quote: 'Trích dẫn',
    receivingAdvice: 'Nhận lời khuyên',
    despacthAdviceReference: 'Tham khảo lời khuyên gửi',
    organizationSales: 'Bán hàng tổ chức',
    area: 'Khu vực',
    salesDetail: 'Chi tiết bán hàng',
    oneTimePassword: 'Mật khẩu một lần',
    pleaseEnterYourReceiveCode: 'Vui lòng nhập mã nhận của bạn',
    enterReceiveCode: 'Nhập mã nhận',
    enableOTP: 'Bật OTP',
    sendCode: 'Gửi mã',
    indonesian: 'Indonesia',
    english: 'Tiếng Anh',
    uzbekistan: 'Uzbekistan',
    russian: 'tiếng Nga',
    roleSelection: 'Lựa chọn vai trò',
    userSelection: 'Lựa chọn người dùng',
    taskName: 'Tên nhiệm vụ',
    shippingLetter: 'Thư vận chuyển',
    senderContact: 'Người gửi liên hệ',
    street: 'Đường phố',
    restrictions: 'Những hạn chế',
    senderTelephone: 'Điện thoại người gửi',
    warehouse: 'Kho',
    shippingNumber: 'Số lượng vận chuyển',
    shippingDate: 'Ngày vận chuyển',
    receiverContact: 'Người nhận liên hệ',
    receiverTelephone: 'Người nhận điện thoại',
    totalColie: 'Tổng số colie',
    uploadAttachment: 'Tải Tệp đính kèm',
    register: 'Đăng ký',
    registerText: 'tạo tài khoản của bạn',
    createAccount: 'Tạo tài khoản',
    quoteReference: 'Trích dẫn tài liệu tham khảo',
    quoteCurrency: 'Trích dẫn tiền tệ',
    quoteDate: 'Ngày trích dẫn',
    orderCurrency: 'Đặt hàng tiền tệ',
    fileName: 'Tên tập tin',
    requestQuantity: 'Số lượng yêu cầu',
    invoiceDate: 'Ngày hóa đơn',
    sender: 'Người gửi',
    organizationParent: 'Tổ chức cha mẹ',
    grandTotal: 'Tổng cộng',
    parentCompany: 'Công ty mẹ',
    documentTypeStatus: 'Trạng thái Loại & Tài liệu',
    assetTypeStatus: 'Loại tài sản & trạng thái',
    lineItemRevision: 'Sửa đổi mục dòng',
    assetStatus: 'Tình trạng tài sản',
    backToLoginPage: 'Quay lại trang đăng nhập',
    virtualAccountNumber: 'Số tài khoản ảo',
    remark: 'Nhận xét',
    printPdf: 'In pdf',
    registrationNumber: 'Số đăng ký',
    details: 'Chi tiết',
    configProperty: 'Tài sản',
    configValue: 'Giá trị',
    accountType: 'Kiểu tài khoản',
    accountNumber: 'Số tài khoản',
    showRelativeTime: 'Hiển thị thời gian tương đối',
    showDocumentRead: 'Hiển thị trạng thái đọc tài liệu',
    funderRequiredAccountTypes: 'Loại tài khoản tài khoản',
    buyerRequiredAccountTypes: 'Loại tài khoản người mua',
    sellerRequiredAccountTypes: 'Loại tài khoản người bán',
    financialRequest: 'Yêu cầu tài chính',
    paymentId: 'ID thanh toán',
    financingTenor: 'Tài chính cho thuê',
    calculationStartDate: 'Ngày bắt đầu tính toán',
    maximumFinancingTenor: 'Tổ chức tài chính tối đa',
    interestRate: 'Lãi suất',
    commissionAmount: 'Hoa hồng',
    total: 'Tổng cộng',
    financialInformation: 'Thông tin tài chính',
    whtinterstRate: 'Lãi suất WHT',
    interestAmount: 'Số tiền lãi',
    requestDate: 'Ngày yêu cầu',
    customerType: 'loại khách hàng',
    about: 'Về',
    interestIndex: 'Chỉ số lãi suất',
    contactUs: 'Liên hệ chúng tôi',
    download: 'Tải xuống',
    uploadAccurate: 'Tải lên chính xác',
    sales: 'Việc bán hàng',
    approvalMatrix: 'Ma trận phê duyệt',
    approvalMatrixList: 'Danh sách ma trận phê duyệt',
    approvalMatrixDetail: 'Chi tiết ma trận phê duyệt',
    productMaintenance: 'Bảo trì sản phẩm',
    itemDescription: 'mô tả món hàng',
    size: 'Kích cỡ',
    priceList: 'Bảng giá',
    priceTier: 'Mức giá',
    productDetail: 'Chi tiết sản phẩm',
    productCreate: 'Tạo sản phẩm',
    addPrice: 'Thêm giá',
    stockValidation:
        'Không thể tiến hành giao dịch báo giá, vui lòng bổ sung kho của bạn trước khi tiếp tục',
    failedValidation: 'Không xử lý nhiệm vụ',
    levelType: 'Loại cấp độ',
    dateCreated: 'Ngày thành lập',
    maximumCreditLine: 'Tín dụng tối đa',
    outstandingCredit: 'Tín dụng vượt trội',
    availableCreditLimit: 'Giới hạn tín dụng có sẵn',
    funderName: 'Tên tài trợ',
    maximumTenor: 'Tối đa tenor',
    financingPercentage: 'Tỷ lệ tài chính',
    invoiceAmount: 'Số tiền hóa đơn',
    invoiceDiscount: 'Giảm giá hóa đơn',
    interestCost: 'Chi phí lãi',
    fundedAmount: 'Số tiền được tài trợ',
    currentTenor: 'Thuê hiện tại',
    assets: 'Tài sản',
    asset: 'Tài sản',
    assetType: 'Loại tài sản',
    assetAmount: 'Số tiền tài sản',
    originalAmount: 'Số tiền ban đầu',
    funder: 'Tài trợ',
    createNew: 'Tạo mới',
    addLevel: 'Thêm cấp độ',
    addGroup: 'Thêm nhóm',
    groupName: 'Tên nhóm',
    revisedDate: 'Ngày sửa đổi',
    addUser: 'Thêm người phê duyệt',
    approverList: 'Danh sách phê duyệt',
    revisedMessage: 'Bạn có chắc chắn muốn sửa đổi tài liệu này không',
    minimumApprover: 'Người phê duyệt tối thiểu',
    fundingRequest: 'Báo cáo tài chính',
    expectedDisbursementDate: 'Ngày giải ngân dự kiến',
    expectedSettlementDate: 'Ngày giải quyết dự kiến',
    requestedCredit: 'Tín dụng yêu cầu',
    totalLimit: 'Tổng giới hạn',
    vehicleNumber: 'Số xe',
    downPaymentReference: 'Tham khảo thanh toán xuống',
    totalOutstanding: 'Tổng số xuất sắc',
    totalLimitUtilization: 'Tổng số giới hạn sử dụng',
    referenceRate: 'Tỷ giá tham chiếu',
    rateChange: 'Thay đổi tỷ lệ',
    rateChangeLockStatus: 'Tỷ lệ thay đổi trạng thái khóa',
    suspension: 'Đình chỉ',
    commissionRate: 'Tỷ lệ hoa hồng',
    spread: 'Lây lan',
    interestCalculationMethod: 'Phương pháp tính toán',
    brokerFee: 'Phí môi giới',
    othersFee: 'Những người khác phí',
    technologyFee: 'Phí công nghệ',
    insuredPercentage: 'Tỷ lệ phần trăm được bảo hiểm',
    insuredAmount: 'Số tiền được bảo hiểm',
    creditInsurer: 'Công ty bảo hiểm tín dụng',
    stage: 'Sân khấu',
    disbursementDate: 'Ngày yêu cầu giải ngân',
    eligibleAmount: 'Số tiền đủ điều kiện',
    disbursementAmount: 'Số tiền giải ngân',
    discountFee: 'Phí giảm giá',
    arrearsFee: 'Tính phí nợ',
    lateFee: 'Phí trễ',
    payment: 'Sự chi trả',
    feeType: 'Loại phí',
    calculationMethod: 'Phương pháp tính toán',
    calculationRate: 'Tỷ lệ tính toán',
    calculationResult: 'Kết quả tính toán',
    arrears: 'Truy thu',
    transfer: 'Chuyển khoản',
    settlementDate: 'Ngày thanh toán',
    transferDate: 'Ngày chuyển giao',
    actualDisbursementDate: 'Ngày giải ngân thực tế',
    fromAccount: 'Từ tài khoản',
    fromAccountNumber: 'Từ số tài khoản',
    soapResponse: 'Phản ứng',
    soapNarative: 'Narative',
    toAccount: 'Tính toán',
    toAccountNumber: 'Đến số tài khoản',
    amountType: 'Loại số tiền',
    feeDetail: 'Chi tiết phí',
    rateChangesHistory: 'Tỷ lệ thay đổi lịch sử',
    feeInformation: 'Thông tin về phí',
    chargeDetail: 'Chi tiết phí',
    disbursement: 'Giải ngân',
    settlement: 'Giải quyết',
    programName: 'Tên chương trình',
    programDescription: 'Mô tả chương trình',
    stageConfigurations: 'Cấu hình giai đoạn',
    stageNumber: 'Số giai đoạn',
    requiredAccountTypes: 'Loại tài khoản',
    insurance: 'Bảo hiểm',
    organizationCode: 'Mã tổ chức',
    funderSelection: 'Đồng tài trợ',
    funderProperty: 'Tài sản tài trợ',
    buyerProperty: 'Tài sản của người mua',
    sellerProperty: 'Tài sản của người bán',
    dailyCharge: 'Phí hàng ngày',
    requestStatement: 'Tuyên bố yêu cầu',
    dateUpdated: 'Ngày cập nhật',
    financialRequestReference: 'Tài liệu tham khảo yêu cầu tài chính',
    documentChecking: 'Kiểm tra tài liệu',
    close: 'Đóng',
    disbursementHistory: 'Lịch sử giải ngân',
    settlementHistory: 'Lịch sử giải quyết',
    totalDailyCharges: 'Tổng phí hàng ngày',
    totalTenor: 'Tổng số Tenor',
    disburseAmountValidation: '* Số tiền phải bằng với số tiền đủ điều kiện',
    assetDate: 'Ngày tài sản',
    assetDetail: 'Chi tiết tài sản',
    notifications: 'Thông báo',
    notificationSettings: 'Thiết lập thông báo',
    loadMore: 'Tải thêm!',
    repaymentAmount: 'Số tiền trả nợ',
    remainingAmount: 'Số tiền còn lại',
    outstandingAmount: 'Số tiền còn nợ',
    residual: 'Dư',
    residualTransferDate: 'Ngày chuyển còn lại',
    settlementBookingDate: 'Ngày đặt phòng giải quyết',
    actualSettlementDate: 'Ngày giải quyết thực tế',
    processedDocument: 'Báo cáo tài chính',
    settlementAmount: 'Số tiền giải quyết',
    loginContactUs: 'Cần sự trợ giúp? Liên hệ chúng tôi!',
    assetCreationDate: 'Ngày tạo tài sản',
    percentage: 'Tỷ lệ phần trăm',
    automatic: 'Tự động',
    suspend: 'Đình chỉ',
    noConfigurations: 'Không có cấu hình được thêm vào.',
    financialOrganization: 'Tổ chức tài chính',
    addFinancialOrganization: 'Thêm tổ chức tài chính',
    editFinancialOrganization: 'Chỉnh sửa tổ chức tài chính',
    accountName: 'Tên tài khoản',
    bankCode: 'Mã ngân hàng',
    branch: 'Chi nhánh',
    branchName: 'Tên chi nhánh',
    bankName: 'Tên ngân hàng',
    bankAddress: 'Địa chỉ ngân hàng',
    swiftCode: 'Mã Swift',
    bankDetails: 'Thông tin chi tiết ngân hàng',
    addNew: 'Thêm mới',
    approvalConfirm: 'Vui lòng xác nhận sự chấp thuận',
    whtInterest: 'Wht lãi',
    whtInterestAmount: 'Số tiền lãi của wht',
    whtProcessingFee: 'Phí xử lý WHT',
    whtProcessingFeeAmount: 'Số tiền phí xử lý WHT',
    processingFee: 'Phí xử lý',
    totalDisbursementAmount: 'Tổng số tiền giải ngân',
    rate: 'Tỷ lệ',
    rating: 'Tỷ lệ',
    leaveComment: 'Để lại một bình luận',
    method: 'Phương pháp',
    errorRating: 'Tỷ lệ nên được chọn.',
    interest: 'Quan tâm',
    arrears_on_settlement: 'Truy thu giải quyết',
    bankCharge: 'Phí ngân hàng',
    methods: 'Phương pháp',
    disbursementMode: 'Chế độ giải ngân',
    cost: 'Trị giá',
    forms: 'Các hình thức',
    maximumAmount: 'Số tiền tối đa',
    property: 'Tài sản',
    totalCharge: 'Tổng phí',
    extensionSetting: 'Cài đặt mở rộng',
    penaltyEnabled: 'Kích hoạt hình phạt',
    extensionInterest: 'Tiền lãi mở rộng',
    penaltyGracePeriod: 'Thời gian ân hạn hình phạt',
    cycle: 'Chu kỳ phạt',
    penaltyInterest: 'Lãi suất phạt',
    freeze: 'Đông cứng',
    days: 'Ngày',
    interestOnPenalty: 'Quan tâm đến hình phạt',
    arrearsFeeAfterDueDate: 'Phí nợ sau ngày đáo hạn',
    dailyChecking: 'Kiểm tra hàng ngày',
    addPenaltyInterest: 'Thêm vào',
    penalty: 'Hình phạt',
    addPenalty: 'Thêm hình phạt',
    extend: 'Mở rộng',
    maximumExtendedTenor: 'Mức tenor mở rộng tối đa',
    extensionDate: 'Ngày mở rộng',
    limitContractSetting: 'Hạn chế cài đặt hợp đồng',
    maximumCreditLimit: 'Giới hạn tín dụng tối đa',
    overridePercentage: 'Tỷ lệ ghi đè',
    assetPercentage: 'Tỷ lệ tài sản',
    fundingPercentage: 'Tỷ lệ tài trợ',
    activationSetting: 'Cài đặt kích hoạt',
    overrideAmount: 'Ghi đè số lượng',
    enabled: 'Đã bật',
    litigation: 'Kiện tụng',
    proformaInvoice: 'Hóa đơn proforma',
    flowConfigurations: 'Cấu hình dòng chảy',
    programType: 'Loại chương trình',
    flowPreview: 'Xem trước Flow',
    propertySetting: 'Cài đặt thuộc tính',
    inventoryChecking: 'Kiểm tra hàng tồn kho',
    partlyDespatchAdvice: 'Một phần lời khuyên gửi',
    uploadInvoices: 'Tải hóa đơn lên',
    uploadInventory: 'Tải lên hàng tồn kho',
    uploadProduct: 'Tải lên sản phẩm',
    shippingInformation: 'Thông tin vận chuyển',
    participantInformation: 'Thông tin của người tham gia',
    otherInformation: 'Những thông tin khác',
    incoTerm: 'Intermerms',
    bniDirect: 'BNI trực tiếp',
    product: 'Sản phẩm',
    vesselId: 'Tàu ID',
    billOfLadingDate: 'Ngày vận chuyển',
    createOrder: 'Tạo thứ tự',
    standardPercentage: 'Chất lượng nước',
    item: 'Mục',
    balanceStock: 'Cân bằng cổ phiếu',
    valueUpdate: 'Cập nhật giá trị',
    updateStock: 'Cập nhật cổ phiếu',
    invoiceCurrency: 'Tiền tệ hóa đơn',
    invoiceNumber: 'Số hóa đơn',
    incoterm: 'In mạch',
    invoiceLineItem: 'Mục dòng hóa đơn',
    loadPort: 'Cảng Vật nặng',
    dischargePort: 'Cổng xả',
    daysDivisorTitle: 'Số lượng ước số ngày',
    divisor: 'Ưu điểm',
    uploadOrder: 'Tải lên đơn đặt hàng',
    noAction: 'Không có hành động',
    despatchGoodsConfirmation: 'Xác nhận hàng hóa',
    despatchAdviceDate: 'Ngày tư vấn gửi',
    proformaInvoiceReference: 'Tài liệu tham khảo hóa đơn proforma',
    proformaInvoiceDate: 'Ngày hóa đơn proforma',
    buyerContactPhone: 'Người mua điện thoại liên hệ',
    sellerContactPhone: 'Người bán điện thoại liên hệ',
    buyerAccountNumber: 'Số tài khoản người mua',
    sellerAccountNumber: 'Số tài khoản người bán',
    actualWaterContent: 'Hàm lượng nước thực tế',
    waterContentReduction: 'Rafaction',
    proposalRejectionDays: 'Ngày từ chối đề xuất',
    cutOffTime: 'Cắt giảm thời gian (HH: MM: SS)',
    minimumFinancingTenor: 'Tenor tài chính tối thiểu',
    maximumPassDueDate: 'Ngày đến hạn tối đa',
    buyerRecourse: 'Người mua truy đòi',
    buyerSetting: 'Cài đặt người mua',
    sellerRecourse: 'Người bán truy đòi',
    sellerSetting: 'Cài đặt người bán',
    residuals: 'Dư',
    assetSettlement: 'Giải quyết tài sản',
    repaymentDate: 'Ngày trả nợ',
    dilutions: 'Pha loãng',
    manualSettlement: 'Giải quyết thủ công',
    assetNumber: 'Số tài sản',
    settle: 'Ổn định',
    dilution: 'Pha loãng',
    remarks: 'Nhận xét',
    generalLedger: 'Sổ cái chung',
    invoicePurchased: 'Hóa đơn đã mua',
    documentList: 'Danh sách tài liệu',
    accountPayable: 'Tài khoản phải trả',
    disbursementTransferApproval: 'Giải ngân phê duyệt chuyển nhượng',
    settlementTransferApproval: 'Phê duyệt chuyển khoản',
    bankGlNumber: 'Số ngân hàng GL',
    sdReceipt: 'Biên lai SD',
    interestIncome: 'Thu nhập lãi',
    penaltyInterestIncome: 'Thu nhập lãi phạt',
    processingFeeIncome: 'Thu nhập phí xử lý',
    bankCharges: 'Phí ngân hàng',
    accountReceivables: 'Khoản phải thu',
    vatCode: 'Mã VAT',
    disbursementApproval: 'Giải ngân phê duyệt',
    attachmentList: 'Danh sách đính kèm',
    lineItemNoData: 'Không tìm thấy dữ liệu nào.',
    loading: 'Xử lý...',
    start: 'Bắt đầu',
    prepaidAmount: 'Số tiền trả trước',
    downPayment: 'Tiền đặt cọc',
    scheduler: 'Người lập kế hoạch',
    fscm: 'Quản lý chuỗi cung ứng tài chính',
    pleaseSignIn: 'Làm ơn đăng nhập',
    convergenceTag1: 'Cung cấp các giải pháp tài trợ sáng tạo,',
    convergenceTag2: 'Vì vậy, bạn có thể tập trung vào việc phát triển doanh nghiệp của bạn.',
    taskEditDocumentMessage: 'Tài liệu chỉnh sửa thành công.',
    rejectionRemark: 'Nhận xét từ chối',
    priceCorrection: 'Điều chỉnh giá',
    overdueDays: 'Ngày quá hạn',
    creditRating: 'Xếp hạng tín dụng',
    allowFinance: 'Cho phép tài trợ',
    fromInvoice: 'Từ hóa đơn',
    invoiceRecalculate: '* Số tiền sẽ được tính toán lại sau khi tài liệu đã được lưu.',
    qualityAnalysisResult: 'Kết quả phân tích chất lượng',
    testQuality: 'Kết quả kiểm tra trưởng thành gạo',
    standardText: 'Tiêu chuẩn',
    notStandardText: 'Không theo tiêu chuẩn',
    clearSelection: 'Lựa chọn rõ ràng',
    receivedQuantityChecking: 'Nhận được số lượng kiểm tra',
    discountApproval: 'Giảm giá phê duyệt',
    serviceProviderApproval: 'Nhà cung cấp dịch vụ phê duyệt',
    relatedAttachmentList: 'Danh sách đính kèm liên quan',
    bookingOffice: 'Văn phòng đặt phòng',
    jobManagement: 'Quản lý công việc',
    JobScheduler: 'Lập lịch công việc',
    JobSchedulerTrigger: 'Trình kích hoạt lập lịch công việc',
    JobExecutionDetails: 'Chi tiết thực hiện công việc',
    jobName: 'Tên công việc',
    lastRunTime: 'Thời gian chạy lần cuối',
    nextRunTime: 'Thời gian chạy tiếp theo',
    lastResult: 'Kết quả cuối cùng',
    approval: 'Sự chấp thuận',
    JobSchedulers: 'Lập lịch công việc',
    JobExecutions: 'Thực hiện công việc',
    jobInstances: 'Trường hợp công việc',
    calendarName: 'Tên lịch',
    cronExpression: 'Biểu hiện cron',
    activeContract: 'Hợp đồng hoạt động',
    jobActiveEntity: 'Thực thể hoạt động công việc',
    jobPerspective: 'Quan điểm công việc',
    state: 'Tình trạng',
    addTrigger: 'Thêm kích hoạt',
    enable: 'Cho phép',
    disable: 'Vô hiệu hóa',
    referenceSource: 'Nguồn tham chiếu được bật',
    'com.asyx.x4.finprocess.settlement.invalid-settlement-amount':
        '"Số tiền giải quyết không nên lớn hơn" số tiền chưa thanh toán "',
    'com.asyx.x4.user.nofill': 'Vui lòng điền thông tin',
    'com.asyx.x4.user.onlyAlphanumeric_username': 'Tên người dùng không hợp lệ',
    'com.asyx.x4.user.maximumCharacter_username': 'Tên người dùng không hợp lệ',
    'com.asyx.x4.user.onlyAlphabetic_name': 'Tên không hợp lệ',
    'com.asyx.x4.user.manimumCharacter_name': 'Tên không hợp lệ',
    'com.asyx.x4.user.invalidFormat_email': 'địa chỉ email không hợp lệ',
    'com.asyx.x4.user.maximumCharacter_email': 'địa chỉ email không hợp lệ',
    'com.asyx.x4.user.onlyNumeric_mobileNumber': 'Số điện thoại di động không hợp lệ',
    'com.asyx.x4.user.minimumCharacter_mobileNumber': 'Số điện thoại di động không hợp lệ',
    'com.asyx.x4.user.weak_password': 'Mật khẩu không hợp lệ',
    'com.asyx.x4.user.nofill_username': 'Vui lòng điền vào tên người dùng',
    'com.asyx.x4.user.nofill_name': 'Vui lòng điền vào tên',
    'com.asyx.x4.user.nofill_email': 'Vui lòng điền vào địa chỉ email',
    'com.asyx.x4.user.nofill_mobileNumber': 'Vui lòng điền vào số điện thoại di động',
    'com.asyx.x4.user.nofill_password': 'Vui lòng điền mật khẩu',
    'com.asyx.x4.date.nofill': 'Vui lòng chọn ngày',
    'com.asyx.x4.calandar.nofill_name': 'Vui lòng điền vào tên',
    'com.asyx.x4.authorization.user-role_nofill': 'Vui lòng chọn tài khoản người dùng và vai trò',
    'com.asyx.x4.authorization.role_nofill': 'Vui lòng chọn vai trò',
    'com.asyx.x4.authorization.user_nofill': 'Vui lòng chọn tài khoản người dùng',
    'com.asyx.x4.organization.nofill_reference': 'Tham chiếu phải chứa một giá trị',
    'com.asyx.x4.organization.onlyAlphanumeric_reference': 'Tham chiếu không hợp lệ',
    'com.asyx.x4.organization.max_reference': 'Tham chiếu không hợp lệ',
    'com.asyx.x4.organization.nofill_fullname': 'Tên đầy đủ phải chứa một giá trị',
    'com.asyx.x4.organization.max_fullname': 'Tên đầy đủ không hợp lệ',
    'com.asyx.x4.organization.nofill_contactPerson': 'Người liên hệ nên chứa một giá trị',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPerson': 'Người liên hệ không hợp lệ',
    'com.asyx.x4.organization.max_contactPerson': 'Người liên hệ không hợp lệ',
    'com.asyx.x4.organization.nofill_email': 'Email người liên hệ nên chứa một giá trị',
    'com.asyx.x4.organization.invalidFormat_email': 'Email người liên hệ không hợp lệ',
    'com.asyx.x4.organization.max_email': 'Email người liên hệ không hợp lệ',
    'com.asyx.x4.organization.nofill_contactPersonPhone':
        'Điện thoại người liên hệ nên chứa một giá trị',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPersonPhone':
        'Điện thoại người liên hệ không hợp lệ',
    'com.asyx.x4.organization.max_contactPersonPhone': 'Điện thoại người liên hệ không hợp lệ',
    'com.asyx.x4.organization.nofill_city': 'Thành phố nên chứa một giá trị',
    'com.asyx.x4.organization.max_city': 'Thành phố không hợp lệ',
    'com.asyx.x4.organization.nofill_timeZone': 'Múi giờ phải chứa một giá trị',
    'com.asyx.x4.organization.nofill_country': 'Quốc gia nên chứa một giá trị',
    'com.asyx.x4.organization.max_country': 'Quốc gia không hợp lệ',
    'com.asyx.x4.organization.nofill_address1': 'Địa chỉ phải chứa một giá trị',
    'com.asyx.x4.organization.max_address1': 'Địa chỉ không hợp lệ',
    'com.asyx.x4.organization.nofill_contactPersonDepartment':
        'Bộ phận người liên hệ nên chứa một giá trị',
    'com.asyx.x4.organization.onlyAlphabetic_contactPersonDepartment':
        'Bộ phận người liên hệ không hợp lệ',
    'com.asyx.x4.organization.max_contactPersonDepartment': 'Bộ phận người liên hệ không hợp lệ',
    'com.asyx.x4.document.between5to50_refrence':
        'Độ dài tham chiếu phải nằm trong khoảng từ 5 đến 50',
    'com.asyx.x4.invoice.mustPositive_amount': 'Số tiền phải là giá trị dương',
    'com.asyx.x4.document.nofill_currency': 'Vui lòng chọn tiền tệ',
    'com.asyx.x4.invoice.nofill_buyerSeller':
        'Tên người mua và tên người bán nên chứa một giá trị!',
    'com.asyx.x4.invoice.nofill_amount': 'Tổng số tiền nên chứa một giá trị!',
    'com.asyx.x4.invoice.nofill_invoiceReference': 'Tham chiếu hóa đơn nên chứa một giá trị!',
    'com.asyx.x4.invoice.nofill_invoiceDate': 'Ngày hóa đơn nên chứa một giá trị!',
    'com.asyx.x4.invoice.nofill_maturityDate': 'Ngày đáo hạn nên chứa một giá trị!',
    'com.asyx.x4.invoice.nofill_billOfLadingDate': 'Hóa đơn ngày mai nên chứa một giá trị!',
    'com.asyx.x4.finprocess.statement.router.credit_limit_exceeded':
        'Báo cáo tài chính đã vượt quá giới hạn của người tham gia',
    'com.asyx.x4.finprocess.statement.router.credit_limit_contract_exceeded':
        'Báo cáo tài chính đã vượt quá giới hạn hợp đồng',
    'com.asyx.x4.finprocess.statement.router.requestor_suspend':
        'Người yêu cầu đã bị đình chỉ. Vui lòng giải quyết các giao dịch xuất sắc quá hạn hiện có để yêu cầu tài trợ mới.',
    'com.asyx.x4.contract.used_in_transaction':
        'Không xóa hợp đồng vì nó đã được sử dụng bởi (các) giao dịch khác.',
    'com.asyx.x4.error.unknown': 'Đã xảy ra lỗi không xác định, vui lòng thử lại sau.',
    'com.asyx.x4.error.network':
        'Không thể kết nối với máy chủ, vui lòng kiểm tra kết nối Internet của bạn.',
    'com.asyx.x4.document.between1to15_vehicleNumber':
        'Người đề cử Panjang Kendaraan Maksimum 15 chữ số',
    deleteProgramConfirmation: 'Bạn có chắc bạn muốn xóa chương trình không',
    cantUndo: ' "Bạn không thể hoàn tác điều này.",',
    noPermissionDocumentView: '"Bạn không có quyền truy cập vào tài liệu này.",',
    noDataFound: 'Không tìm thấy dữ liệu nào.',
    'b2b.documentDetail': 'Chi tiết tài liệu',
    'b2b.orderTo': 'Đặt hàng đến',
    'b2b.shipTo': 'Tàu',
    'b2b.orderInformation': 'Thông tin đặt hàng',
    'b2b.poStatus': 'Trạng thái PO',
    'b2b.poDate': 'Po ngày',
    'b2b.poExpiredDate': 'PO ngày hết hạn',
    'b2b.poType': 'Loại PO',
    'b2b.partialDelivery': 'Giao hàng một phần',
    'b2b.top': 'ĐỨNG ĐẦU',
    'b2b.producCode': 'Mã sản phẩm',
    'b2b.productName': 'tên sản phẩm',
    'b2b.quantity': 'Đơn hàng số lượng',
    'b2b.price': 'Đơn giá',
    'b2b.items': 'Mặt hàng',
    'b2b.discount': 'Đĩa : ',
    'b2b.discountAmount': 'Số tiền giảm giá',
    'b2b.luxuryTax': 'Thuế sang trọng',
    'b2b.totalPoAmount': 'Tổng số tiền PO',
    'b2b.subtotal': 'Tổng số phụ',
    'b2b.subTotalAfterDiscount': 'Tổng số phụ sau khi giảm giá',
    'b2b.npwp': 'NPWP',
    'b2b.telp': 'Telp',
    'b2b.attn': 'Attn',
    'b2b.fax': 'Số fax',
    'b2b.customerInformation': 'thông tin khách hàng',
    'b2b.billingInformation': 'Thông tin thanh toán',
    docstoreRole: 'Vai trò tổ chức',
    'b2b.customer': 'Khách hàng',
    volume: 'Âm lượng',
    fixedPrice: 'Giá cố định',
    shortName: 'Tên ngắn',
    validFrom: 'Có hiệu lực từ',
    minimumAmount: 'Số tiền tối thiểu',
    taxable: 'Chịu thuế',
    priceTiers: 'Tiers giá',
    assignedEntities: 'Thực thể được giao',
    'b2b.yes': 'Đúng',
    'b2b.no': 'KHÔNG',
    editPrice: 'Chỉnh sửa giá',
    priceDetail: 'Giá chi tiết',
    pricingRules: 'Quy tắc định giá',
    processVariable: 'Biến biến',
    'com.b2b.shortName.isNull': 'Tên ngắn được yêu cầu.',
    'com.b2b.validFrom.isNull': 'Có giá trị là bắt buộc.',
    'com.b2b.discount.isNull': 'Giảm giá là bắt buộc.',
    'com.b2b.minimumAmount.isNull': 'Số tiền tối thiểu là bắt buộc.',
    'com.b2b.amount.isNull': 'Số tiền là bắt buộc.',
    'com.b2b.priceTiers.isEmpty': 'Cần có tối thiểu 1 cấp giá.',
    'com.b2b.priceTier.volume.isEmpty': 'Khối lượng về mức giá không thể trống.',
    'com.b2b.priceTier.fixedPrice.isEmpty': 'Giá cố định trên cấp giá không thể trống.',
    'com.b2b.priceTier.percentage.isEmpty': 'Tỷ lệ phần trăm trên cấp giá không thể trống.',
    'com.b2b.priceTier.processVariable.isEmpty': 'Quy trình biến trên tầng giá không thể trống.',
    priceMaintenance: 'Bảo trì giá',
    countryISOCode: 'Mã ISO quốc gia',
    faxNumber: 'Số fax',
    customerName: 'tên khách hàng',
    settleOrRevise: 'Giải quyết hoặc sửa đổi',
    billingStatements: 'Báo cáo thanh toán',
    customer: 'Khách hàng',
    registrationNo: 'Số đăng ký',
    revision: 'Ôn tập',
    statementDate: 'Ngày tuyên bố',
    minimumFee: 'Phí tối thiểu',
    specification: 'Sự chỉ rõ',
    valueAddedTax: 'Thuế giá trị gia tăng (VAT)',
    requestedDisbursementDate: 'Ngày giải ngân được yêu cầu',
    requestedSettlementDate: 'Ngày giải quyết được yêu cầu',
    signature: 'Chữ ký',
    signatureSender: 'Người gửi:',
    signatureReceiver: 'Người nhận:',
    signatureDate: 'Ngày:',
    signatureApproved: 'Được chấp thuận bởi: Hội đồng Giám đốc',
    addressOne: 'Địa chỉ một',
    addressTwo: 'Địa chỉ hai',
    'No Data Available': 'Không có dữ liệu',
    'com.asyx.x4.user.password_missmatch': 'Mật khẩu hiện tại không',
    'com.asyx.x4.uoa.updatepassword.invalid_length':
        'Mật khẩu của bạn phải chứa chiều dài ít nhất 9 ký tự.',
    'com.asyx.x4.uoa.updatepassword.no_symbol': 'Mật khẩu của bạn phải chứa một biểu tượng.',
    'com.asyx.x4.uoa.updatepassword.no_number': 'Mật khẩu của bạn phải chứa một số.',
    'com.asyx.x4.uoa.updatepassword.no_upper_case': 'Mật khẩu của bạn phải chứa các chữ cái trên.',
    'com.asyx.x4.uoa.updatepassword.no_lower_case':
        'Mật khẩu của bạn phải chứa các chữ cái chữ thường.',
    'com.asyx.x4.uoa.updatepassword.contain_space': 'Mật khẩu của bạn không thể chứa không gian.',
    'com.asyx.x4.uoa.updatepassword.contain_symbol_number':
        'Mật khẩu của bạn phải chứa ký hiệu và số.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_upper':
        'Mật khẩu của bạn phải chứa ký hiệu, số và vỏ trên.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_lower':
        'Mật khẩu của bạn phải chứa ký hiệu, số và chữ thường.',
    'resetPassword.maximumAttempt': 'Quá nhiều nỗ lực. (Tối đa 3 lần một ngày)',
    'com.asyx.x4.user.password_has_been_used':
        'Mật khẩu này đã được sử dụng trước đây. Vui lòng chọn mật khẩu mới.',
    confirmPassword: 'Xác nhận mật khẩu',
    passwordResetSuccess: 'Mật khẩu được cập nhật, chuyển hướng bạn sang trang đăng nhập',
    orClick: 'hoặc nhấp',
    here: 'đây',
    showUploadProductTips:
        'Để đăng ký một danh sách lớn các sản phẩm, bạn có thể tải lên các tệp trong',
    thisPage: 'trang này',
    dontRemind: 'đừng nhắc nhở',
    goToLoginPage: 'đi bây giờ.',
    signatureName: 'Tên:',
    transferAfterGR: 'Chuyển tiếp sau khi nhận tốt',
    transferAfterQualityApproval: 'Chuyển nhượng sau khi phê duyệt chất lượng',
    transferAfterGRValidation: 'Chuyển tiếp sau khi nhận được nên chứa một giá trị.',
    transferAfterQualityApprovalValidation:
        'Chuyển giao sau khi phê duyệt chất lượng sẽ chứa một giá trị',
    'Apr On Asset Amount': 'APR trên số tiền tài sản',
    'Apr On Disbursement Amount': 'APR về số tiền giải ngân',
    'Apr On Eligible Amount': 'APR với số tiền đủ điều kiện',
    'Apr On Original Amount': 'APR với số tiền ban đầu',
    'Percentage Of Asset Amount': '% số tiền tài sản',
    'Percentage Of Disbursement Amount': '% số tiền giải ngân',
    'Percentage Of Eligible Amount': '% số tiền đủ điều kiện',
    'Percentage Of Original Amount': '% số tiền ban đầu',
    accountEnabled: 'Tài khoản được bật',
    accountDisabled: 'tài khoản bị vô hiệu hóa',
    accountLocked: 'Tài khoản bị khóa',
    accountUnlocked: 'Mở khóa tài khoản',
    unlockAccount: 'Mở khoá tài khoản',
    showMore: 'Cho xem nhiều hơn ...',
    showMoredata: 'Cho xem nhiều hơn',
    showLessdata: 'Hiện ít hơn',
    viewJobExecution: 'Xem thực thi',
    apmsReference: 'Tham khảo APMS',
    viewJobInstances: 'Xem các trường hợp',
    totalPO: 'Số lượng po',
    percentage_of_asset_amount: '% số tiền tài sản',
    percentage_of_disbursement_amount: '% số tiền giải ngân',
    percentage_of_eligible_amount: '% số tiền đủ điều kiện',
    percentage_of_original_amount: '% số tiền ban đầu',
    apr_of_asset_amount: 'APR của số tiền tài sản',
    apr_of_disbursement_amount: 'APR của số tiền giải ngân',
    apr_of_eligible_amount: 'APR của số tiền đủ điều kiện',
    apr_of_original_amount: 'APR của số tiền ban đầu',
    apr_of_remaining_disbursement_amount: 'APR của số tiền giải ngân còn lại',
    calculationTypeValue: 'Kiểu',
    calculationType: 'Loại tính toán',
    penaltyCalculationType: 'Loại tính toán hình phạt',
    signatures: 'Chữ ký',
    principalAmount: 'Số tiền gốc',
    exportCsv: 'Xuất CSV',
    exportPdf: 'Xuất PDF',
    exportExcel: 'Xuất XLS',
    exportXml: 'Xuất XML',
    exportMt940: 'Xuất khẩu MT940',
    exportProcessingMessage: 'Chúng tôi đang xử lý tệp của bạn, vui lòng đợi ...',
    'hover.accept.disbursement_approval': 'Nhấp vào nút này sẽ giải ngân báo cáo tài chính.',
    'hover.accept.asset_financing_funder_approval':
        'Nhấp vào nút này để tiến hành tài liệu báo cáo tài chính để bắt đầu giải ngân.',
    'hover.accept.asset_financing_requester_approval':
        'Nhấp vào nút này để tiến hành tài liệu báo cáo tài chính cho nhà cung cấp dịch vụ hoặc nhà tài trợ.',
    'hover.accept.service_provider_approval':
        'Nhấp vào nút này để tiến hành tài liệu báo cáo tài chính để phê duyệt tài trợ.',
    'hover.reject.disbursement_approval':
        'Nhấp vào nút này Một nhận xét từ chối nên được cung cấp và tài liệu báo cáo tài chính sẽ bị từ chối hoàn toàn. Sau khi bị từ chối, người bán nên bắt đầu một yêu cầu mới trong tương lai.',
    'hover.reject.asset_financing_funder_approval':
        'Nhấp vào nút này sẽ từ chối tài liệu báo cáo tài chính. Sau khi bị từ chối, người bán nên bắt đầu một yêu cầu mới trong tương lai.',
    'hover.reject.service_provider_approval':
        'Nhấp vào nút này sẽ từ chối tài liệu báo cáo tài chính. Sau khi bị từ chối, người bán nên bắt đầu một yêu cầu mới trong tương lai.',
    'hover.cancel.asset_financing_requester_approval':
        'Nhấp vào nút này sẽ hủy bỏ bản bắt đầu báo cáo tài chính.',
    'hover.edit.service_provider_approval':
        'Nhấp vào nút này để chỉnh sửa tài liệu báo cáo tài chính để tải lên (các) tài liệu hỗ trợ.',
    'hover.edit.asset_financing_requester_approval':
        'Nhấp vào nút này để chỉnh sửa tài liệu báo cáo tài chính để xác nhận.',
    'hover.revise.disbursement_approval':
        'Nhấp vào nút này Một nhận xét sửa đổi nên được cung cấp và tài liệu tuyên bố tài chính sẽ được gửi lại cho người dùng nhà sản xuất tài trợ để sửa đổi.',
    'Too many attempt':
        'Đặt lại mật khẩu đã được yêu cầu 3 lần, vui lòng đợi cho đến ngày hôm sau hoặc liên hệ với ASYX Support',
    update: 'Cập nhật',
    discountType: 'Loại giảm giá',
    dataConfirmation: 'Xác nhận dữ liệu',
    dataHoverError: 'Lỗi (s) tìm thấy trên tệp này.',
    dataHoverSuccess: 'Tệp là tốt và sẵn sàng để tải lên.',
    csvReviewErrors: 'Cần được sửa chữa trước:',
    buyerReference: 'Tham khảo người mua',
    sellerReference: 'Tham khảo người bán',
    settlementForm: 'Mẫu giải quyết',
    attachFiles: 'Đính kèm tệp',
    chooseFile: 'Chọn tập tin',
    addFile: 'Thêm tập tin',
    settlementConfirmation: 'Xác nhận giải quyết',
    attachments: 'Đính kèm',
    createCreditNote: 'Tạo ghi chú tín dụng',
    creditNote: 'Ghi chú tín dụng',
    beginingOfInvoiceAmount: 'Bắt đầu số tiền hóa đơn',
    endingOfInvoiceAmount: 'Kết thúc số tiền hóa đơn',
    creditNoteAmount: 'Số tiền ghi chú tín dụng',
    history: 'Lịch sử',
    loggingIn: 'Đăng nhập...',
    updatePassword: 'Cập nhật mật khẩu',
    enterCurrentPassword: 'Vui lòng nhập mật khẩu hiện tại của bạn',
    enterNewPassword: 'Vui lòng nhập mật khẩu mới của bạn',
    generalErrorMessage:
        'Có gì đó sai, xin vui lòng liên hệ với sự hỗ trợ của chúng tôi để được hỗ trợ thêm.',
    too_many_attempt:
        'Mật khẩu đã được gửi 3 lần, vui lòng đợi cho đến ngày hôm sau hoặc liên hệ với ASYX Hỗ trợ.',
    assign: 'Giao phó',
    editCreditNoteAmount: 'Chỉnh sửa số tiền ghi chú tín dụng',
    assignCreditNote: 'Gán ghi chú tín dụng',
    assignInvoice: 'Chỉ định hóa đơn',
    selectInvoice: 'Chọn Hóa đơn',
    interestIndexManagement: 'Quản lý chỉ số lãi suất',
    lastUpdate: 'Cập nhật cuối cùng',
    interestIndexDetail: 'Chỉ số quan tâm chi tiết',
    interestIndexEdit: 'Chỉnh sửa chỉ số quan tâm',
    InterestIndexAdd: 'Chỉ số quan tâm thêm',
    notificationTemplate: 'Mẫu thông báo',
    fromDate: 'Từ ngày',
    toDate: 'Cho đến nay',
    rateUpdates: 'Cập nhật đánh giá',
    reconciliation: 'Sự hòa giải',
    reconciliationAmount: 'Số tiền hòa giải',
    otherCharges: 'Các khoản phí khác',
    additionalReimbursement: 'Hoàn trả bổ sung',
    difference: 'Sự khác biệt',
    reconcile: 'Hòa giải',
    reconciliationForm: 'Hình thức hòa giải',
    confirm: 'Xác nhận',
    'com.asyx.x4.reconciliation.nofill_buyer': 'Vui lòng chọn ít nhất 1 người mua.',
    'com.asyx.x4.reconciliation.nofill_currencies': 'Vui lòng chọn ít nhất 1 loại tiền tệ.',
    'com.asyx.x4.reconciliation.nofill_repaymentDate': 'Ngày trả nợ phải được lấp đầy.',
    'com.asyx.x4.reconciliation.invalid_repayment_amount': 'Số tiền trả nợ không thể trống.',
    'com.asyx.x4.reconciliation.invalid_difference_amount': 'Sự khác biệt phải bằng không.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_configuration':
        'Tên và cấu hình đã được sử dụng.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_days':
        'Cấu hình và ngày đã được sử dụng.',
    creditNoteReference: 'Tài liệu tham khảo ghi chú tín dụng',
    switchUserType: 'Chuyển loại người dùng',
    selectUserType: 'Chọn loại người dùng',
    supplier: 'Nhà cung cấp',
    quoteFormLoading: 'Chuẩn bị biểu mẫu của bạn, xin vui lòng đợi ...',
    noLineItems: 'Không có mặt hàng được thêm vào.',
    moneyMovementReport: 'Báo cáo chuyển động tiền',
    trannsactionType: 'Loại giao dịch',
    responseType: 'Loại phản ứng',
    inactiveDialogTitle: 'Xin chào, bạn vẫn còn ở đó không?',
    inactiveDialogMessage:
        'Đối với bảo mật tài khoản của bạn, bạn sẽ tự động đăng xuất nếu không có hoạt động sau một thời gian.',
    inactiveDialogButton: 'Vâng, vui lòng đợi',
    tenor: 'Kỳ hạn',
    viewDetail: 'xem chi tiết',
    switchUser: 'Chuyển đổi người dùng',
    totalUserSelected: 'Tổng số người dùng đã chọn:',
    totalDocumentSelected: 'Tổng tài liệu được chọn:',
    cloneUser: 'Người dùng nhân bản',
    cloneUsernameValidation: '* Tên người dùng phải khác với người dùng ban đầu.',
    paymentInformation: 'Thông tin thanh toán',
    priceType: 'Loại giá',
    owner: 'Người sở hữu',
    'com.task.validation.emptyQc': 'Hình thức chất lượng phải được lấp đầy.',
    'com.asyx.x4.qcvalidation.standardPercentage': 'Vui lòng điền vào chất lượng nước.',
    'com.asyx.x4.qcvalidation.seedAmount': 'Vui lòng điền vào số lượng hạt giống.',
    'com.asyx.x4.qcvalidation.maxDirt': 'Vui lòng điền vào bụi bẩn tối đa.',
    'com.asyx.x4.qcvalidation.maxMushroom': 'Vui lòng điền vào nấm tối đa.',
    'com.asyx.x4.qcvalidation.maxSkinContent': 'Vui lòng điền vào nội dung da tối đa.',
    'com.asyx.x4.qcvalidation.notSalty': 'Vui lòng điền vào không mặn.',
    calculating: 'Tính toán ...',
    settlementValidation: 'Số tiền giải quyết phải thấp hơn hoặc bằng số lượng còn lại.',
    seedAmount: 'Số lượng hạt giống',
    maxDirt: 'Bụi bẩn tối đa',
    maxMushroom: 'Nấm tối đa',
    maxSkinContent: 'Nội dung da tối đa',
    notSalty: 'Không mặn',
    additional: 'Thêm vào',
    startPeriod: 'thời gian bắt đầu',
    inactivityPeriod: 'Thời kỳ không hoạt động',
    emailNotificationactivation: 'Kích hoạt thông báo qua email',
    activeEmailNotification: 'Thông báo email tích cực',
    inActiveEmailNotification: 'Thông báo email không hoạt động',
    documentStatusActivation: 'Hiển thị tài liệu đọc kích hoạt trạng thái',
    activeDocumentRead: 'Tài liệu hoạt động đọc trạng thái',
    inActiveDocumentRead: 'Tài liệu không hoạt động đọc trạng thái',
    relativeTimeActivation: 'Hiển thị kích hoạt thời gian tương đối',
    activeRelativeTime: 'Hiển thị thời gian tương đối',
    inActiveRelativeTime: 'Hiển thị thời gian tương đối không hoạt động',
    otpActivation: 'Kích hoạt mật khẩu một lần',
    activeOtp: 'Mật khẩu một lần hoạt động',
    inActiveOtp: 'Mật khẩu không hoạt động',
    accountStatus: 'Tình trạng tài khoản',
    enabledAccount: 'Tài khoản được bật',
    disabledAccount: 'tài khoản bị vô hiệu hóa',
    lockedAccount: 'Tài khoản bị khóa',
    ldapAccount: 'Tài khoản LDAP',
    activeLdap: 'Tài khoản LDAP hoạt động',
    inActiveLdap: 'Tài khoản LDAP không hoạt động',
    addBankInformation: 'Thêm thông tin ngân hàng',
    supplierList: 'Danh sách nhà cung cấp',
    addSupplier: 'Thêm nhà cung cấp mới',
    supplierEmail: 'Email nhà cung cấp',
    buyerList: 'Danh sách người mua',
    addBuyer: 'Thêm người mua mới',
    buyerEmail: 'Email người mua',
    phoneNumber: 'Số điện thoại',
    requiredNote: '* Yêu cầu',
    createAnother: 'Thêm một cái khác',
    addParticipantSuccess: 'Thêm thành công.',
    uncdfRegisterText: 'Hoàn thành thông tin đăng ký của bạn',
    ageRange: 'Độ tuổi',
    lessThan24: 'Dưới 24',
    over24: '24 trở lên',
    buyerOrSupplier: 'Bạn là người mua hoặc nhà cung cấp?',
    passwordDidNotMatch: '* Xác nhận mật khẩu không khớp.',
    usernameAlphanumeric: '* Tên Người dùng không thể chứa ký tự đặc biệt.',
    usernameMin5: '* Tên người dùng phải có ít nhất 5 ký tự.',
    passwordMin: '* Mật khẩu phải có ít nhất 9 ký tự.',
    passwordAlphanumeric: '* Mật khẩu phải chứa: số, chữ hoa, ký tự đặc biệt và chữ thường.',
    userCreated: 'Tài khoản của bạn đã được tạo.',
    clickHereToLogin: 'Nhấn vào đây để đi đến trang đăng nhập.',
    usernameExists: '* Tên người dùng này đã được lấy.',
    registrationLinkExpired:
        'Liên kết đăng ký này đã hết hạn, xin vui lòng liên hệ với hỗ trợ của chúng tôi.',
    male: 'Nam giới',
    female: 'Nữ giới',
    genderNull: 'Thay vì không nói',
    gender: 'Giới tính',
    next: 'Kế tiếp',
    back: 'Mặt sau',
    organizationOrCompany: 'Tổ chức / Tên công ty',
    profit: 'Ước tính lợi nhuận',
    npwp: 'Mã số thuế',
    numberOfEmployees: 'Số lượng nhân viên',
    community: 'Bạn đến từ cộng đồng nào?',
    done: 'Xong',
    userProfile: 'Hồ sơ',
    businessInformation: 'Thông tin kinh doanh',
    accountInformation: 'thông tin tài khoản',
    finish: 'Hoàn thành',
    tooltipUsername1: '- Tối thiểu 5 ký tự.',
    tooltipPassword1: '- Tối thiểu 9 ký tự.',
    tooltipPassword2: '- Phải chứa (các) ký tự chữ hoa (A-Z).',
    tooltipPassword3: '- Phải chứa (các) ký tự viết thường (A-Z).',
    tooltipPassword4: '- Phải chứa (các) số (0-9).',
    tooltipPassword5: '- Phải chứa (các) ký hiệu (ví dụ!!, $, #, V.v.).',
    organizationNotComplete:
        'Trước khi thực hiện bất kỳ giao dịch nào, vui lòng hoàn thành hồ sơ kinh doanh của bạn',
    alreadyExists: 'đã tồn tại.',
    billingStatus: 'Tình trạng thanh toán',
    actived: 'Hoạt động',
    suspended: 'Cấm',
    activity: 'Hoạt động',
    documents: 'Các tài liệu',
    accountSettings: 'Cài đặt tài khoản',
    logout: 'Đăng xuất',
    from: 'Từ',
    to: 'ĐẾN',
    noTaskFound: 'Không tìm thấy nhiệm vụ',
    success: 'Thành công',
    minimumRange: 'Phạm vi tối thiểu',
    maximumRange: 'Phạm vi lớn nhất',
    createProduct: 'Tạo sản phẩm',
    createInventory: 'Tạo hàng tồn kho',
    createForm: 'Tạo biểu mẫu',
    updateForm: 'Cập nhật biểu mẫu',
    form: 'Hình thức',
    addAnswer: 'Thêm câu trả lời',
    required: 'Yêu cầu',
    formName: 'Tên hình thức',
    formDescription: 'Mô tả biểu mẫu',
    manageForm: 'Quản lý biểu mẫu',
    duplicate: 'Nhân bản',
    fillForm: 'Điền vào mẫu',
    editForm: 'Chỉnh sửa câu trả lời',
    viewForm: 'Xem biểu mẫu',
    answerSubmitted: 'Câu trả lời đã gửi.',
    answer: 'Trả lời',
    keyword: 'Từ khóa',
    suspensions: 'Đình chỉ',
    creditLimitExpiryDate: 'Hết hạn hạn chế tín dụng',
    forever: 'Mãi mãi',
    spesificDate: 'Ngày Spesific',
    overdueAmount: 'Số tiền quá hạn',
    dashboard: 'bảng điều khiển',
    tasks: 'Nhiệm vụ',
    administration: 'Sự quản lý',
    users: 'Người dùng',
    banks: 'Ngân hàng',
    roles: 'Vai trò',
    programs: 'Chương trình',
    contracts: 'Hợp đồng',
    jobs: 'Việc làm',
    file: 'Tài liệu',
    auditTrail: 'Đường mòn kiểm toán',
    referenceSourceNav: 'Nguồn tham khảo',
    reporting: 'Báo cáo',
    documentReport: 'Báo cáo tài liệu',
    bookingOfficeMonitoringTools: 'Công cụ giám sát văn phòng đặt phòng',
    customerReport: 'Báo cáo khách hàng',
    relationDetail: 'Chi tiết quan hệ',
    transactionReport: 'Báo cáo giao dịch',
    response: 'Phản ứng',
    transferDetailsReference: 'Chuyển chi tiết tham khảo',
    statusTransfer: 'Chuyển giao trạng thái',
    fsStatus: 'Trạng thái FS',
    narrative: 'Chuyện kể',
    proposal: 'Đề xuất',
    transactionType: 'Loại giao dịch',
    financingReport: 'Báo cáo tài chính',
    reportEngine: 'Báo cáo động cơ',
    moneyMovement: 'Chuyển động tiền',
    createDocument: 'Tạo tài liệu',
    quotes: 'Trích dẫn',
    invoices: 'Hóa đơn',
    accurate: 'Chính xác',
    downpayment: 'Tiền đặt cọc',
    inventory: 'Hàng tồn kho',
    inventoryReport: 'Báo cáo hàng tồn kho',
    invoiceSettlement: 'Giải quyết hóa đơn',
    products: 'Các sản phẩm',
    contact: 'Liên hệ',
    feeTemplate: 'Mẫu phí',
    feeManagement: 'Quản lý phí',
    chargesPlan: 'Kế hoạch phí',
    executionPhaseFee: 'Giai đoạn thực hiện',
    outstanding: 'Nổi bật',
    invoicedFee: 'Phí lập hóa đơn',
    cycleFee: 'Xe đạp',
    nameFee: 'Tên',
    confirmNewPasswordMsg: 'Vui lòng nhập lại mật khẩu mới của bạn',
    feeTemplateDetail: 'Phí mẫu chi tiết',
    feeName: 'Tên lệ phí',
    executionPhase: 'Giai đoạn thực hiện',
    gracePeriod: 'Thời gian ân hạn',
    oneTime: 'Một lần',
    daily: 'Hằng ngày',
    weekly: 'Hàng tuần',
    monthly: 'Hàng tháng',
    preCharges: 'Phí trước',
    postCharges: 'Đăng phí',
    initiate: 'Bắt đầu',
    early: 'Sớm',
    extension: 'Sự mở rộng',
    late: 'Muộn',
    tierType: 'Loại cấp',
    static: 'Tĩnh',
    dynamic: 'Năng động',
    formula: 'Công thức',
    copy: 'Sao chép',
    none: 'Không có',
    void: 'Vô hiệu',
    postPoned: 'Hoãn lại',
    signup: 'Đăng ký',
    userNameMinimalValidation: 'Tên người dùng phải có ít nhất 5 ký tự',
    userNameRequiredValidation: 'Tên người dùng là bắt buộc!',
    userNameMatchValidation: 'Tên người dùng không thể chứa các ký tự đặc biệt  n',
    nameMinimalValidation: 'Tên phải có ít nhất 5 ký tự',
    nameRequiredValidation: 'Tên là bắt buộc!',
    mobileNumberMinimalValidation: 'Số điện thoại di động phải có ít nhất 10 ký tự',
    mobileNumberRequiredValidation: 'Số điện thoại di động là bắt buộc!',
    emailAddressValidation: 'địa chỉ email không hợp lệ',
    emailAddressRequiredValidation: 'Email thì cần thiết!',
    passwordMinimalValidation: 'Mật khẩu phải có ít nhất 9 ký tự!',
    passwordMatchValidation: 'Mật khẩu phải chứa: số, chữ hoa, ký tự đặc biệt và chữ thường',
    passwordRequiredValidation: 'Mật khẩu là bắt buộc!',
    confirmPassValidation: 'Mật khẩu phải phù hợp với',
    confirmPassRequiredValidation: 'Yêu cầu xác nhận mật khẩu!',
    captchaRequiredValidation: 'Captcha là bắt buộc!',
    registerSuccessMessage:
        'Tên người dùng có thể được xác minh sau khi gửi và CAPTCHA được cập nhật nếu tên người dùng đã được lấy',
    createAccountSuccessMessage: 'Thành công để tạo tài khoản',
    hoverInformation: 'Di chuột trên',
    hoverDescription: 'Biểu tượng hiển thị số lượng thập phân đầy đủ',
    available: 'Có sẵn',
    completed: 'Hoàn thành',
    transactionWidget: 'Giao dịch',
    overdueTab: 'Quá hạn',
    outstandingTab: 'Nổi bật',
    transactionValue: 'Giá trị giao dịch hàng đầu',
    viewFullList: 'Xem danh sách đầy đủ',
    maximum: 'Tối đa',
    all: 'Tất cả',
    upcomingSettlements: 'Các khu định cư sắp tới',
    upcomingSettlementEmailNotification: 'Thông báo email định cư sắp tới',
    participantName: 'Tên người tham gia',
    number: 'Con số',
    financingOverview: 'Tổng quan tài chính',
    balanceWidget: 'Tiện ích cân bằng',
    verifyEmail: 'Xác nhận Email',
    inventoryList: 'Danh mục hàng tồn kho',
    inventoryDetail: 'Chi tiết hàng tồn kho',
    inventoryDetailByDate: 'Chi tiết kiểm kê cho mỗi ngày',
    roleAdd: 'Vai trò thêm',
    roleEdit: 'Chỉnh sửa vai trò',
    createUserProfile: 'Tạo hồ sơ người dùng',
    editUserProfile: 'Chỉnh sửa hồ sơ người dùng',
    editUser: 'Người dùng biên tập',
    createOrganization: 'Tạo tổ chức',
    editOrganization: 'Chỉnh sửa tổ chức',
    createCalendar: 'Tạo lịch',
    editCalendar: 'Chỉnh sửa lịch',
    createAuthorization: 'Tạo ủy quyền',
    editAuthorization: 'Chỉnh sửa ủy quyền',
    organizationAuthDetail: 'Tổ chức chi tiết ủy quyền',
    createSales: 'Tạo doanh số',
    editSales: 'Chỉnh sửa bán hàng',
    fileExport: 'Xuất tập tin',
    auditTrailDetail: 'Chi tiết kiểm toán',
    noAttachmentAdded: 'Không có tệp đính kèm được thêm vào.',
    statusHistory: 'Lịch sử trạng thái',
    currentState: 'Tình trạng hiện tại',
    exemption: 'Miễn trừ',
    totalDataSelected: 'Tổng dữ liệu được chọn:',
    creditLimitExpiryDateRemark:
        'Cơ sở giới hạn tín dụng đã hết hạn, vui lòng gia hạn nó bằng cách liên hệ với nhà tài trợ.',
    creditLimitModal: 'Cơ sở tín dụng cho tổ chức này đã hết hạn, dù sao cũng tiếp tục?',
    bypassFunder: 'Bỏ qua tài trợ',
    originAccount: 'Tài khoản gốc',
    destinationAccount: 'Tài khoản đích',
    bulkFinancing: 'Tài chính số lượng lớn',
    fundAllocation: 'Phân bổ quỹ',
    fundAllocationRateBelow100: 'Phân bổ tỷ lệ phải là 100%.',
    fundAllocationRateAbove100: 'Phân bổ tỷ lệ phải là 100%.',
    fundAllocationOriginEmpty: 'Vui lòng chọn Tài khoản Origin.',
    fundAllocationDestinationEmpty: 'Vui lòng chọn Tài khoản đích.',
    fundAllocationSubmitted: 'Phân bổ quỹ được gửi.',
    amortizationDate: 'Ngày khấu hao',
    amortizationHistory: 'Lịch sử khấu hao',
    amortizationAmount: 'Số tiền khấu hao',
    addProperty: 'Thêm tài sản',
    valueType: 'Loại giá trị',
    extensionRequest: 'Yêu cầu gia hạn',
    extensionTenor: 'Tenor mở rộng',
    activation: 'Kích hoạt',
    feeSettings: 'Cài đặt phí',
    settlementExtension: 'Giải quyết gia hạn',
    settlementExtensionSetting: 'Cài đặt mở rộng giải quyết',
    addRabate: 'Thêm giảm giá',
    rabate: 'Hạ giá',
    rabateSetting: 'Thiết lập giảm giá',
    rebateTiering: 'Giảm giá tầng',
    vatPercentage: 'Ppn perentase',
    bulkExtension: 'Mở rộng số lượng lớn',
    bulkExtensionRequestForm: 'Mẫu mở rộng số lượng lớn',
    settlementExtensionRequestForm: 'Mẫu gia hạn giải quyết',
    selectedDocuments: '(Các) tài liệu đã chọn',
    extensionDueDate: 'Ngày mở rộng đến hạn',
    extensionHistory: 'Lịch sử mở rộng',
    extensionFee: 'Phí gia hạn',
    settlementExtensionDueDate: 'Ngày mở rộng giải quyết ngày đáo hạn',
    settlementExtensionHistory: 'Lịch sử mở rộng giải quyết',
    settlementExtensionFee: 'Phí gia hạn giải quyết',
    settlementExtensionTenor: 'Giải quyết mở rộng kỳ hạn',
    dueDateLessThanMaturityDate: 'Ngày mở rộng ngày đáo hạn phải nhiều hơn ngày đáo hạn.',
    pickDate: 'Bấm để chọn một ngày ...',
    'com.asyx.x4.finprocess.extension.not_found.financing_statement':
        'Báo cáo tài chính không tìm thấy.',
    'com.asyx.x4.finprocess.extension.invalid_tag':
        'Trạng thái/thẻ không hợp lệ. Trạng thái/thẻ được phép được giải ngân/mở rộng.',
    'com.asyx.x4.finprocess.extension.invalid_disbursement': 'Giải ngân không tìm thấy.',
    'com.asyx.x4.finprocess.extension.multi_payment_date':
        'Không thể xử lý các báo cáo tài chính với ngày giải ngân nhiều thanh toán.',
    'com.asyx.x4.finprocess.extension.multi_financing_tenor':
        'Không thể xử lý các báo cáo tài chính với nhiều khoản tiền tài chính của khoản giải ngân.',
    'com.asyx.x4.finprocess.extension.multi_tag':
        'Không thể xử lý các báo cáo tài chính với tình trạng khác nhau.',
    'com.asyx.x4.finprocess.extension.multi_contract':
        'Không thể xử lý các báo cáo tài chính với hợp đồng khác nhau.',
    'com.asyx.x4.finprocess.extension.multi_recourse':
        'Không thể xử lý các báo cáo tài chính với sự truy đòi khác nhau.',
    'com.asyx.x4.finprocess.extension.multi_currency':
        'Không thể xử lý các báo cáo tài chính với tiền tệ khác nhau.',
    'com.asyx.x4.finprocess.extension.not_found.contract_participant_stage':
        'Hợp đồng tham gia giai đoạn không tìm thấy.',
    'com.asyx.x4.finprocess.extension.restriction.extension_tenor':
        'Tenor mở rộng nhiều hơn mức tenor mở rộng tối đa.',
    'com.asyx.x4.finprocess.extension.waiting_approval.extension':
        'Không thể yêu cầu gia hạn vì (các) tài liệu đang chờ phê duyệt hoặc đã được gia hạn.',
    extensionRequested: 'Yêu cầu gia hạn được gửi.',
    settlementExtensionRequested: 'Yêu cầu gia hạn giải quyết được gửi.',
    'com.asyx.x4.finprocess.extension.restriction.deselect_all':
        'Vui lòng chọn ít nhất một báo cáo tài chính, hoặc từ chối nhiệm vụ thay thế.',
    'com.asyx.x4.finprocess.extension.restriction.unregistered_financing_statement':
        'Lỗi! Báo cáo tài chính chưa đăng ký.',
    'com.asyx.x4.finprocess.extension.restriction.tenor_exceed': 'Tenor vượt quá tối đa',
    'com.asyx.x4.organizationFreeze':
        'Organization is freeze. Please check Credit Limit Expiry Date / Credit Rating / Overdue Transaction. Please contact Bank Administrator.',
    'com.asyx.x4.contractFreeze':
        'Contract is freeze, has occurred overdue amount / overdue days. Please contact Bank administrator.',
    extensionDetail: 'Chi tiết mở rộng',
    settlementExtensionDetail: 'Giải quyết chi tiết mở rộng',
    extensionID: 'ID mở rộng',
    extendedDueDate: 'Ngày đến hạn',
    extensionType: 'Loại mở rộng',
    transferDetails: 'Chuyển chi tiết',
    retry: 'Thử lại',
    retryBookingOffice: 'Văn phòng đặt phòng thử lại',
    bookingOfficeExecutionHistory: 'Lịch sử thực hiện văn phòng đặt phòng',
    lastExecutionStartTime: 'Thời gian bắt đầu thực hiện lần cuối',
    lastExecutionEndTime: 'Thời gian cuối thực hiện lần cuối',
    duration: 'Khoảng thời gian',
    executions: 'Thực thi',
    executedBy: 'Thực hiện bởi',
    beginningStatus: 'Trạng thái ban đầu',
    endStatus: 'Trạng thái cuối cùng',
    executionDateTime: 'Ngày & giờ thực hiện',
    deliveryLocation: 'Vị trí giao hàng',
    expetedInvoiceMaturityDate: 'Ngày đáo hạn hóa đơn',
    descriptionNull: 'Mô tả mục phải được lấp đầy',
    totalAssetPercentage: 'Tổng tỷ lệ phần trăm tài sản',
    transactionInquiry: 'Yêu cầu giao dịch',
    periodInquiry: 'Giai đoạn',
    beginningBalance: 'Bắt đầu cân bằng',
    totalDebit: 'Tổng số ghi nợ',
    totalCredit: 'Tổng số tín dụng',
    postDate: 'Ngay gưỉ',
    journalNo: 'Tạp chí số',
    debitOrCredit: 'Db/cr',
    balance: 'Sự cân bằng',
    configurationTools: 'Công cụ cấu hình',
    participant: 'Người tham gia',
    parameterType: 'Loại tham số',
    freezed_account: 'Tài khoản đóng băng',
    unfreezed_account: 'Tài khoản chưa được giải quyết',
    proposal_after_office_hour: 'Đề xuất sau giờ hành chính',
    manual_proposal_creation: 'Tạo ra thủ công',
    without_transfer_approval: 'Mà không cần sự chấp thuận chuyển nhượng',
    credit_limit_expired_date: 'Ngày hạn chế tín dụng đã hết hạn',
    vatNull: 'VAT phải được điền hoặc chọn',
    pageNumber: 'Số trang',
    dateFrom: 'Từ ngày',
    dateTo: 'Ngày tới',
    expectedInvoiceMaturityDate: 'Ngày đáo hạn hóa đơn dự kiến',
    outstandingTransactions: 'Giao dịch nổi bật',
    fscmOutstanding: 'FSCM nổi bật',
    iconsOutstanding: 'Biểu tượng nổi bật',
    addDocumentLink: 'Thêm liên kết tài liệu',
    documentLink: 'Liên kết tài liệu',
    selectOrder: 'Chọn thứ tự',
    financingAfterCutOffTime: 'Tài chính sau khi cắt giảm thời gian',
    rowsPerPage: 'Hàng trên mỗi trang',
    payFees: 'Trả phí',
    cifNumber: 'Số CIF',
    branchInformation: 'Chi nhánh',
    synchronize: 'Làm cho đồng bộ',
    yes: 'Đúng',
    not: 'KHÔNG',
    ok: 'Được rồi',
    syncOrganizationConfirmationTitle: 'Đồng bộ hóa dữ liệu tổ chức',
    syncOrganizationConfirmationMessage: 'Bạn có muốn đồng bộ hóa dữ liệu của tổ chức này không?',
    synchronizeSuccessMessage: 'Quá trình đồng bộ hóa hoàn thành.',
    bulkSyncOrganizationConfirmationMessage:
        'Bạn có muốn đồng bộ hóa (các) dữ liệu tổ chức này không?',
    failed: 'Thất bại',
    result: 'Kết quả',
    reason: 'Lý do',
    'com.asyx.x4.uoa.synchronize.failed.not_deposit': 'Loại tài khoản không phải là tiền gửi.',
    'com.asyx.x4.uoa.synchronize.failed.not_available': 'Số tài khoản không có sẵn.',
    'com.asyx.x4.uoa.synchronize.failed.no_giro': 'Tổ chức không có tài khoản Giro.',
    syncContractConfirmationTitle: 'Đồng bộ hóa dữ liệu hợp đồng',
    syncContractConfirmationMessage: 'Bạn có muốn đồng bộ dữ liệu của hợp đồng này không?',
    bulkSyncContractConfirmationMessage:
        'Bạn có muốn đồng bộ hóa (các) dữ liệu hợp đồng này không?',
    'com.asyx.x4.finconfig.synchronize.failed.account_number_not_found':
        'Tổ chức không có số tài khoản.',
    'com.asyx.x4.finconfig.synchronize.failed.no_data_from_icons':
        'Không có phản hồi từ các biểu tượng, số CIF có khả năng không hợp lệ.',
    'com.asyx.x4.finconfig.synchronize.failed.contract_participant_not_found':
        'Người tham gia hợp đồng không tìm thấy.',
    bulkSettleConfirmation: 'Xác nhận số lượng lớn',
    bulkSettleConfirmationMsg: 'Sự khác biệt không bằng 0',
    bulkSettleConfirmationDetail:
        '* Nếu bạn muốn tiếp tục quá trình này, vui lòng nhấp vào nút bên dưới',
    'login.invalidUsernamePassword': 'Tên người dùng/mật khẩu không hợp lệ, vui lòng thử lại.',
    'login.expiredPassword': 'Mật khẩu hết hạn, vui lòng liên hệ với quản trị viên.',
    'login.accountLocked': 'Tài khoản bị khóa, vui lòng liên hệ với Quản trị viên',
    'login.generalFailure': 'Không thể kết nối với máy chủ, vui lòng thử lại.',
    welcomeText: 'Chào mừng đến với ASYX X4',
    welcome: 'CHÀO MỪNG',
    loginToYourAccount: 'đăng nhập vào tài khoản của bạn',
    checkMail: 'Kiểm tra thư của bạn',
    resetPasswordInstructionMsg: 'Chúng tôi đã gửi hướng dẫn khôi phục mật khẩu vào email của bạn.',
    'com.asyx.x4.invalid_captcha': 'Captcha không hợp lệ.',
    serverStatus: 'Trạng thái máy chủ',
    bniContactUs: 'Liên hệ chúng tôi',
    bniWelcomeText: 'Chào mừng đến với dịch vụ BNI FSCM',
    creditDebitNote: 'Ghi chú tín dụng/ghi nợ',
    others: 'Người khác',
    bniRedirectErrorMsg: 'Vui lòng chuyển hướng lại, phiên của bạn đã hết hạn.',
    bniRedirectManualLogin: 'Đăng nhập thủ công ở đây',
    bniRedirectSuccessMsg: 'Đăng nhập thành công, chúng tôi sẽ chuyển hướng bạn đến cổng sớm ...',
    bniRedirectSuccessManual: 'Nhấp vào đây nếu bạn chưa được chuyển hướng sau 5 giây.',
    bulkSettlement: 'Giải quyết số lượng lớn',
    bulkSettlementConfirmation: 'Tiến hành giải quyết hàng loạt với các tài liệu này?',
    bulkSettlementFailed: 'Quá trình giải quyết số lượng lớn không thành công.',
    'com.asyx.x4.finprocess.settlement.invalid-size':
        'Số lượng báo cáo tài chính được chọn nên ít nhất 1 hoặc ít hơn hoặc bằng 100 tài liệu.',
    'com.asyx.x4.finprocess.settlement.create.invalid-status':
        'Chỉ các báo cáo tài chính mở rộng được giải ngân, giải quyết một phần hoặc giải quyết hoặc giải quyết mới được phép được yêu cầu.',
    'com.asyx.x4.finprocess.settlement.edit.invalid-status':
        'Các báo cáo tài chính được lựa chọn nên có trạng thái đang chờ giải quyết.',
    'com.asyx.x4.finprocess.settlement.invalid-currency':
        'Các báo cáo tài chính được chọn nên có cùng một loại tiền tệ',
    'com.asyx.x4.finprocess.settlement.invalid-relation':
        'Các báo cáo tài chính được lựa chọn nên có cùng một mối quan hệ tổ chức.',
    'com.asyx.x4.finprocess.settlement.invalid-payment-date':
        'Các báo cáo tài chính được chọn nên có cùng ngày thanh toán giải ngân.',
    'com.asyx.x4.uoa.organization.failed-delete':
        'Thất bại trong việc xóa tổ chức, tổ chức đã được hợp đồng. Vui lòng kiểm tra lại.',
    uploadSettlement: 'Tải lên giải quyết',
    FinancingStatementReference: 'Tài liệu tài chính Tài liệu tham khảo',
    RepaymentDate: 'Ngày trả nợ',
    RepaymentAmount: 'Số tiền trả nợ',
    ResidualTransferDate: 'Ngày chuyển còn lại',
    level: 'Mức độ',
    showApprovers: 'Xem người phê duyệt',
    approver: 'Người phê duyệt',
    help: 'Giúp đỡ',
    helpBookingOffice:
        'Văn phòng đặt phòng là một tính năng chức năng để thực hiện các giao dịch với tích hợp trên biểu tượng. Người dùng có thể thực hiện các giao dịch bằng cách sử dụng tích hợp biểu tượng bằng cách kích hoạt các công tắc có sẵn (giải ngân, thanh toán hoặc cả hai).',
    helpErrorMsg: 'Tài liệu trợ giúp không tải, bấm vào để thử lại',
    childs: 'Công ty trẻ em',
    limitSettings: 'Giới hạn cài đặt',
    followsContractLimit: 'Tuân theo giới hạn hợp đồng',
    checkNetPlafond: 'Kiểm tra net plafond',
    limitAllocation: 'Giới hạn phân bổ',
    allocationPercentage: 'Tỷ lệ phân bổ',
    allocationPercentageValidation: 'Tổng phân bổ không được vượt quá 100%',
    exports: 'Xuất tập tin',
    propertyConfiguration: 'Cấu hình tài sản',
    penalties: 'Hình phạt',
    outstandingParameters: 'Các thông số nổi bật',
    disbursementPhases: 'Giai đoạn giải ngân',
    settlementPhases: 'Giai đoạn giải quyết',
    settlementExtensionPhases: 'Giai đoạn mở rộng giải quyết',
    accounts: 'Tài khoản',
    generalLedgerSf: 'Đặt cài đặt GL SF',
    generalLedgerDf: 'Đặt cài đặt GL DF',
    generalLedgerSd: 'Đặt cài đặt GL SD',
    data: 'Dữ liệu',
    message: 'Sự kiện',
    auditTags: 'Nhãn',
    timestamp: 'Dấu thời gian',
    reconciliationReport: 'Báo cáo đối chiếu',
    totalResiduals: 'Tổng số dư',
    adjustmentBankCharges: 'Điều chỉnh - Phí ngân hàng',
    adjustmentCreditNote: 'Điều chỉnh - Lưu ý tín dụng',
    adjustmentOthers: 'Điều chỉnh - những người khác',
    process: 'Quá trình',
    ipAddress: 'Địa chỉ IP',
    field: 'Cánh đồng',
    before: 'Trước',
    after: 'Sau đó',
    eventDetail: 'Chi tiết sự kiện',
    noAdditionalData: 'Không có dữ liệu bổ sung',
    holidayList: 'Danh sách ngày lễ',
    emptyExclusions: '* Vui lòng cung cấp ngày vào mỗi ngày loại trừ',
    downloadTemplate: 'Tải xuống mẫu',
    uploadOrganizationCalendar: 'Tải lên lịch tổ chức',
    fileSelected: 'Tệp được chọn',
    fileUploaded: 'Tập tin được tải lên thành công.',
    holidayFinancingStatement: 'Báo cáo tài chính ngày lễ',
    autoSettlementDetails: 'Chi tiết giải quyết tự động',
    deleteCalendar: 'Xóa lịch',
    oldData: 'Dữ liệu cũ',
    newData: 'Dữ liệu mới',
    cannotDeletePastDate: 'Ngày quá khứ hoặc ngày nay không thể bị xóa.',
    invoiceList: 'Danh sách hóa đơn',
    'com.asyx.x4.document.duplicate_invoice_reference':
        'Không thể cập nhật tài liệu, có (các) tham chiếu trùng lặp.',
    invoiceApproval: 'Phê duyệt hóa đơn',
    documentInformation: 'thông tin tài liệu',
    invoiceApprovalEditFirst: 'Bạn cần nhấp vào nút Chỉnh sửa trước.',
    referenceAlreadyExist: 'Tham khảo đã tồn tại.',
    fileTooLarge: 'Kích thước tệp tối đa 50 MB',
    checking: 'Kiểm tra ...',
    calendarDateAlreadyExist: 'Ngày lịch đã tồn tại, xin vui lòng chọn một ngày khác.',
    otpSmsForm: 'SMS mật khẩu một lần',
    otpEmailForm: 'Email mật khẩu một lần',
    'com.asyx.x4.invoices.exceeds_limit': 'Số tiền hóa đơn vượt quá giới hạn có sẵn',
    automaticDisbursement: 'Giải ngân tự động',
    passwordUpdated: 'Mật khẩu của bạn đã được thay đổi thành công.',
    otpSent: 'Mã OTP đã được gửi đến',
    pleaseVerifyOtpBelow: ', xin vui lòng xác minh nó dưới đây.',
    didNotReceiveOtp: 'Không nhận được mã OTP?',
    resendOtp: 'Resend OTP',
    verifyOtp: 'Xác minh OTP',
    'com.asyx.x4.incorrect_otp': 'Mã OTP không chính xác.',
    jobExecutionEnabled: 'Thực hiện công việc được kích hoạt',
    addConfiguration: 'Thêm cấu hình',
    normalPaymentValue: 'Giá trị thanh toán bình thường',
    bulkExtensionError:
        'Tiện ích mở rộng số lượng lớn chưa được cấu hình cho giao dịch này, vui lòng kiểm tra hợp đồng hoặc quản trị viên liên hệ của bạn.',
    bulkSettlementExtensionError:
        'Tiện ích mở rộng giải quyết chưa được cấu hình cho giao dịch này, vui lòng kiểm tra hợp đồng hoặc quản trị viên liên hệ của bạn.',
    chooseDate: 'Bấm để chọn một ngày ...',
    maxFileSize: 'Tối đa. Kích thước tập tin',
    plafond: 'Plafond',
    disponible: 'Có thể giải tán',
    holdAmount: 'Giữ số lượng',
    netPlafond: 'Net Plafond',
    loadingCaptcha: 'Đang tải Captcha ...',
    reloadCaptcha: 'Tạo captcha mới',
    enterCaptcha: 'nhập mã xác nhận',
    reloadCaptchaDelay: 'Thứ hai trước khi có thể tạo ra CAPTCHA mới.',
    tools: 'Công cụ',
    activityTools: 'Công cụ hoạt động',
    activityHistory: 'Lịch sử hoạt động',
    submitDuplicateMessage: 'Vui lòng kiểm tra lại mã mục này',
    submitDuplicate: 'Xác nhận trùng lặp',
    collaborationCreditLimit: 'Giới hạn tín dụng hợp tác',
    rateChanges: 'Thay đổi tỷ lệ',
    uploadRate: 'Tỷ lệ tải lên',
    referenceRatePercentage: 'Tỷ lệ tham chiếu tỷ lệ phần trăm',
    funderSpreadPercentage: 'Tỷ lệ chênh lệch tài trợ',
    sharedRevenuePercentage: 'Tỷ lệ phần trăm doanh thu chia sẻ',
    brokerFeePercentage: 'Tỷ lệ phí môi giới',
    technologyFeePercentage: 'Tỷ lệ phí công nghệ',
    processingFeePercentage: 'Phí xử lý tỷ lệ phần trăm',
    collectionFeePercentage: 'Phí thu phí phần trăm',
    commissionFeePercentage: 'Tỷ lệ phí hoa hồng',
    othersFeePercentage: 'Người khác phí tỷ lệ phần trăm',
    financingStatement: 'Báo cáo tài chính',
    rateChangeApproval: 'Phê duyệt thay đổi tỷ lệ',
    changeDate: 'Đã thay đổi ngày',
    quoteRestriction: 'Trích dẫn hạn chế',
    quoteRestrictionDays: 'Trích dẫn ngày hạn chế',
    announcement: 'THÔNG BÁO',
    quoteRestrictionChecking: 'Vui lòng đợi, kiểm tra hạn chế báo giá.',
    contractNameEmpty: 'Thiếu thông tin: Tên hợp đồng!',
    currencyContractLimitSettingEmpty: 'Vui lòng chọn Tiền tệ về Cài đặt Hợp đồng Giới hạn!',
    maximumCreditLimitContractEmpty: 'Thiếu thông tin: Giới hạn tín dụng tối đa!',
    overridePercentageContractEmpty: 'Thiếu thông tin: ghi đè tỷ lệ phần trăm!',
    optionRatesCurrencyEmpty: 'Vui lòng chọn Tiền tệ theo số của Divisor!',
    optionRatesDivisorEmpty: 'Vui lòng chọn Divisor theo số của Divisor!',
    proposalRejectionDaysEmpty: 'Thiếu thông tin: Ngày từ chối đề xuất!',
    minimumFinancingTenorEmpty: 'Thiếu thông tin: Tenor tài chính tối thiểu!',
    signatureMessage:
        'Ở đây, chúng tôi xác nhận rằng chúng tôi đồng ý với các chi tiết của báo cáo tài chính này.',
    changeAppLogo: 'Thay đổi logo ứng dụng',
    resetAppLogo: 'Đặt lại logo ứng dụng',
    changeLogo: 'Thay đổi logo',
    serviceActionTeam: 'Đội hành động dịch vụ (SAT)',
    vietnam: 'Việt Nam',
    overpayment: 'Overpayment',
    underpayment: 'Underpayment',
    pph23: 'PPH23',
    amountDue: 'Amount Due',
    b2bPayment: 'Payment',
    taskDetailEditInformation: 'Vui lòng xem lại tài liệu và xác nhận các chi tiết',
    totalSettlementAmount: 'tổng số tiền thanh toán',
    fundAvailable: 'quỹ có sẵn',
    pranota: 'Pra Nota',
    receivedDate: 'Received Date',
    uploadPraNota: 'Upload Pra Nota',
    principal: 'Principal',
    referenceDate: 'Reference Date',
    contractNotFoundBuyer: 'Contract not found for buyer',
    andSupplier: 'and supplier',
    currencyFor: 'Currency for',
    isIrrelevantExistingContract: 'is irrelevant with the existing contract',
    isIrrelevantExistingContractCurrency: 'is irrelevant with the existing contract',
    for: 'for',
    shouldContainValue: 'should contain a value',
    lengthBetween5and50: 'Reference length should be between 5 and 50',
    shouldPositiveAmount: 'should be positive amount',
    isInvalidReference: 'is invalid reference',
    rowCannotEmpty: 'Row data cannot be empty',
    cannotNegativeValue: 'cannot be negative value',
    cannotMoreThan100: 'cannot more than 100',
    cannotFutureDate: 'cannot be a future date',
    cannotLessThan: 'cannot be less than',
    cannotLessThanToday: 'cannot be less than today',
    lengthShouldLessThan255Characters: 'length should be less than 255 characters',
    formatCNDNincorrect:
        'format is incorrect, CN / DN Amount should only numeric, no characters or symbols allowed',
    formatRTRNincorrect:
        'format is incorrect, RTRN Amount should only numeric and always in negative, no characters or symbols allowed except -',
    formatARincorrect:
        'format is incorrect, AR Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    formatIncorrect: 'format is incorrect',
    amountShouldNumeric:
        'Amount should only numeric and always in positive, no characters or symbols or negative amount allowed',
    totalAmountMoreThanZero: 'Total amount must more than zero, references',
    withTotalAmount: 'with total amount',
    shouldMore5And365days: 'Payment Term should be more than 0 and less than 365 days',
    activeOrganizationNotRelevant:
        'Active organization is not relevant with the row organization data',
    formatIncorect: 'format incorect',
    formatIsNotCorrect: 'Format is not correct for',
    shouldBeYYYYMMDD: 'It should be YYYYMMDD',
    amountFormatIncorect: 'Format',
    invoiceCode: 'Invoice Reference',
    invoiceamount: 'Invoice Amount',
    numberToDate: 'Payment Term',
    Reference: 'Referensi',
    maximalAmountMsg:
        'The total amount exceeds the system limit. Please revise and ensure it is not more than 15 digits.',
    shortMaximalAmountMsg: 'Total amount cannot more than 15 digits',
    shortMaximalAmountRowMsg: 'Amount cannot more than 15 digits',
    invoicereference: 'Invoice Reference',
    invoicecurrency: 'Invoice Currency',
    invoicedate: 'Invoice Date',
    format: ' ',
    receiveddate: 'Received Date',
    addNewParticipant: 'Add New Participant',
    invoicesCannotLessThanToday:
        'Invoices with a date earlier than today cannot be uploaded. Please ensure the invoice date is today or in the future',
};
